import "shared/extensions/date";
import { AccountSecurityModuleCard } from "./Components/ModuleCard/ModuleCard";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import { useAccountSecurityData } from "./data";

export const AccountSecurity = () => {
  const { t } = useTranslation();
  const { accountSecurityModulesData } = useAccountSecurityData();
  return (
    <>
      <PageTitle title={t("pageTitle.account.accountSecurity.index")} />
      <PageHeader title={t("accountSecurity.home.heading")} hideForMobile hideBackForDesktop />
      <div className="flex flex-col space-y-12">
        {accountSecurityModulesData
          .filter((data) => !data.hide)
          .map((data) => (
            <AccountSecurityModuleCard key={data.title} {...data} />
          ))}
      </div>
    </>
  );
};
